import { type PropsWithChildren } from 'react';
import { usePage } from '@inertiajs/react';

interface AuthLayoutProps {
    title?: string;
    description?: string;
    wide?: boolean;
}

interface PageProps extends Record<string, unknown> {
    appName?: string;
    appLogo?: string;
    name?: string;
}

export default function AuthSimpleLayout({
    children,
    title,
    description,
}: PropsWithChildren<AuthLayoutProps>) {
    const { props } = usePage<PageProps>();
    const appName = props.appName || (props.name as string) || 'AIunify';
    const authLogo = (props.appLogo as string | undefined) || '/logo.svg';

    return (
        <div className="pbau-auth-shell">
            <main className="pbau-auth-page">
                <div className="pbau-auth-bg" aria-hidden="true">
                    <span className="pbau-auth-particle pbau-auth-particle--one" />
                    <span className="pbau-auth-particle pbau-auth-particle--two" />
                    <span className="pbau-auth-particle pbau-auth-particle--three" />
                    <span className="pbau-auth-particle pbau-auth-particle--four" />
                    <span className="pbau-auth-grid" />
                    <span className="pbau-auth-ribbon pbau-auth-ribbon--one" />
                    <span className="pbau-auth-ribbon pbau-auth-ribbon--two" />
                    <span className="pbau-auth-veil" />
                </div>

                <div className="pbau-auth-frame">
                    <div className="pbau-auth-brand">
                        <div className="w-full max-w-[320px]" aria-label={appName}>
                            <img
                                src={authLogo}
                                alt={appName}
                                className="pbau-auth-brand__image"
                            />
                        </div>
                    </div>

                    <section className="pbau-auth-card">
                        <div className="mb-6 text-center max-sm:mb-4">
                            <h1 className="pbau-auth-title">
                                {title || 'Log in'}
                            </h1>
                            {description && (
                                <p className="pbau-auth-description">
                                    {description}
                                </p>
                            )}
                        </div>
                        {children}
                    </section>
                </div>
            </main>
        </div>
    );
}
